<template>
  <div>
    <section class="section ibcgp-page-hero">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 m-auto">
            <h1 class="ibcgp-heading-display">
              Quem somos nós?
            </h1>

            <p>
              Somos uma associação sem fins lucrativo, que surgiu da congruência de ideais e valores de profissionais com ampla experiência na gestão pública em diversas áreas do conhecimento. 
              Os desafios da Administração Pública são diversos! 
              Estão presentes em todos os setores e repartições, principalmente quando o assunto é prestar um bom serviço público com parcos recursos financeiros.
              Melhorar a gestão de um Município não é simples, mas o IBCGP nasceu com a vocação de transmitir conhecimento, capacitar os gestores e servidores, produzir análises gerenciais e principalmente fornecer tecnologia.
              Os softwares são grandes aliados no processo de modernização da gestão pública, sua aplicação gera controle, transparência, efetividade.
              A persecução desse objetivo não é maior que a necessidade altruísta de impactar positivamente a sociedade em que vivemos, por isso o IBCGP conta com projetos sociais de capacitação à população carente e apoio financeiro a outras instituições beneficentes. 
              O que nos move é o profundo desejo de transformar a sociedade atual.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section about p-0">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 align-self-center">
            <div class="content text-center text-lg-left">
              <h2>A <b>missão</b> do instituto</h2>

              <p>
                Uma administração pública eficiente em gestão, gerindo seus recursos com inteligência, controlando suas receitas com primazia, 
                fornecendo serviço público com excelência, diminuindo a desigualdade e promovendo oportunidade aos menos favorecidos.

                Aprimorar a gestão pública, por meio de ferramentas tecnológicas, da disseminação de conhecimento e promover o desenvolvimento social e educacional do país, 
                utilizando experiência, valores éticos na realização de seus processos.
              </p>
            </div>
          </div>

          <div class="col-lg-6 mt-4 mt-lg-0">
            <div class="about-slider">
              <div class="item">
                <img class="w-100" 
                      src="../../assets/images/ibcgp/mission.jpg" 
                      alt="Imagem de missão do instituto"
                      style="border-radius: 15px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section about p-0">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 mt-4 mt-lg-0">
            <div class="about-slider">
              <div class="item">
                <img class="w-100" 
                      src="../../assets/images/ibcgp/vision.jpg" 
                      alt="Imagem da visão do instituto"
                      style="border-radius: 15px;">
              </div>
            </div>
          </div>

          <div class="col-lg-6 mt-4 mt-lg-0 align-self-center">
            <div class="content text-center text-lg-right">
              <h2>Nossa <b>visão</b></h2>

              <p>
                Uma administração pública eficiente em gestão, gerindo seus recursos com inteligência, 
                controlando suas receitas com primazia, fornecendo serviço público com excelência, 
                diminuindo a desigualdade e promovendo oportunidade aos menos favorecidos
              </p>
            </div>
          </div>            
        </div>
      </div>
    </section>

    <section class="section about p-0">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 align-self-center">
            <div class="content text-center text-lg-left">
              <h2>Uma instituição de <b>valores</b></h2>

              <p>
                Excelência na execução de suas atividades. 
                Cooperação institucional para compartilhar competências, 
                definir e atingir objetivos comuns.
                <br><br>
                Valorizar as pessoas reconhecendo que o desempenho do Instituto depende do desenvolvimento, 
                do bem-estar e da realização profissional do seu capital humano. 
                Comprometimento profissional com o atendimento dos objetivos institucionais e com a realização de propósitos comuns e duradouros.
                <br><br>
                Interação permanente com a sociedade para atendimento de suas necessidades e divulgação dos resultados do Instituto, facilitando o acesso à informação, produtos e serviços gerados.
                <br><br>
                Responsabilidade Social com atuação balizada pela ética, pela transparência e pelo respeito à sociedade, e ao desenvolvimento sustentável.
              </p>
            </div>
          </div>

          <div class="col-lg-6 mt-4 mt-lg-0">
            <div class="about-slider">
              <div class="item">
                <img class="w-100" 
                      src="../../assets/images/ibcgp/values.jpg" 
                      alt="Imagem de valores do instituto"
                      style="border-radius: 15px;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section cta-hire bg-gary">
      <contact/>
    </section>
  </div>
</template>

<script>
  import Contact from '../contact/ShortcutContact.vue';

  export default {
    components:{
      'contact'       : Contact
    }
  }
</script>